/*
 * @Author: crazycattle
 * @Date: 2021-10-29 14:12:13
 * @Description: content
 */
import axios from "axios";
import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  applyChannelAction: root + "/Client/applyChannelAction",
  getsucessclient: root + "/Client/sucessclient",
  getsucessclientExport: root + "/Client/sucessclient/Export",
  getMarketer: root + "/Public/getMarketerApi",
  getArealyCourseApi: root + "/Api/getArealyCourseApi",
  delDonversionAction: root + "/Client/delDonversionAction",
  getChannel: root + "/Public/getChannelApi",
  getSource: root + "/Public/getSourceApi",
  trackClientAction: root + "/Client/trackClientAction",
  // addClient:root+"/Client/addClientAction",
  getClientStudentApi: root + "/Client/getClientStudentApi", //招生有效名单->获取可选推荐人-lujing
  addClientSponsorAction: root + "/Client/addClientSponsorAction", // 个人详情->增加推荐人-lujing

  getReMarketerApi: root + "/Public/getReMarketerApi",
};
const storeRegisteredList = {
  applyChannelAction(params) {
    return axios.post(url.applyChannelAction, qs.stringify(params));
  },
  //已报名名单
  getsucessclient(params) {
    return axios.get(url.getsucessclient, { params });
  },
  //已报名名单---导出
  getsucessclient1() {
    return isGraySchoolEnabled() ? url.getsucessclientExport : url.getsucessclient;
  },
  // 获取招生的负责人
  getMarketer(params) {
    return axios.get(url.getMarketer, { params });
  },
  //获取课程
  getArealyCourseApi(params) {
    return axios.get(url.getArealyCourseApi, { params });
  },
  // 获取招生渠道类型
  getSource(params) {
    return axios.get(url.getSource, {
      params,
    });
  },
  // 获取招生渠道明细
  getChannel(params) {
    return axios.get(url.getChannel, {
      params,
    });
  },
  getClientStudentApi(params) {
    return axios.get(url.getClientStudentApi, {
      params,
    });
  },
  getReMarketerApi(params) {
    return axios.get(url.getReMarketerApi, {
      params,
    });
  },
  // Crm->删除转正记录-
  delDonversionAction(params) {
    return axios.post(url.delDonversionAction, qs.stringify(params));
  },
  // 招生目标线索->跟进客户
  trackClientAction(params) {
    return axios.post(url.trackClientAction, qs.stringify(params));
  },
  addClientSponsorAction(params) {
    return axios.post(url.addClientSponsorAction, qs.stringify(params));
  },
};

export default storeRegisteredList;
